module.exports = __webpack_public_path__ + "img/back.5761ddeb.jpg";